var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"contenedor-catalogo"},_vm._l((_vm.artistas),function(artista){return _c('router-link',{key:artista.id_artista,attrs:{"to":"canciones"}},[_c('ThumbArtista',{attrs:{"artista":artista,"id_artista":artista.id_artista}})],1)}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }